import styles from "./HighlightedText.module.css";

/**
 * Renders a sentence made of plain-text segments and highlighted "pill" terms, e.g.
 * ["What does the ", { pill: "Local Voter Score" }, " look like in ", { pill: "Missouri" }].
 * Shared by the search bar's rich placeholder and the landing page's template cards so
 * both use the same pill styling. Purely decorative -- neither caller clicks an individual pill
 * (a template card's whole card is its own click target; the placeholder's pills are just a
 * preview of what you can search for).
 *
 * `variant`: "template" (template cards, the default) or "placeholder" (the search input's rich
 * placeholder) -- the two Token States the Search Guidance Figma gives these.
 */
const HighlightedText = ({ segments, variant = "template" }) => {
  return (
    <>
      {segments.map((segment, index) =>
        typeof segment === "string" ? (
          <span key={index}>{segment}</span>
        ) : (
          <span key={index} className={`${styles.pill} ${styles[variant] ?? styles.template}`}>
            {segment.pill}
          </span>
        )
      )}
    </>
  );
};

export default HighlightedText;
